var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import React from 'react';
// https://jsport.aws.justsystems.com/bunkyo-next/next-design/-/blob/master/data/note/parts/cloud.svg
var Cloud = React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 31, height: 23, viewBox: "0 0 31 23", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M12.5 1.5c1.377 0 2.667.37 3.776 1.018a7.54 7.54 0 013.32 4.042A3.465 3.465 0 0122.5 5c.966 0 1.841.392 2.475 1.025A3.489 3.489 0 0126 8.5a3.486 3.486 0 01-1.072 2.518c.457.035.911.127 1.353.278a5.509 5.509 0 012.697 2.01A5.473 5.473 0 0130 16.5a5.482 5.482 0 01-1.541 3.818 5.483 5.483 0 01-3.744 1.678h0L6.539 22a6.028 6.028 0 01-3.933-1.912A5.988 5.988 0 011 16a5.97 5.97 0 01.931-3.212 6.029 6.029 0 012.52-2.222h0l.629-.295-.057-.691a7.477 7.477 0 012.174-5.883A7.477 7.477 0 0112.5 1.5z", stroke: "currentColor", strokeWidth: 2, fill: "none", fillRule: "evenodd" })));
});
// https://jsport.aws.justsystems.com/bunkyo-next/next-design/-/blob/master/data/note/parts/semicircle.svg
var SemiCircle = React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 14, height: 14, viewBox: "0 0 14 14", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M6.996 1.496a5.5 5.5 0 105.5 5.5", stroke: "currentColor", strokeWidth: 2, fill: "none", fillRule: "evenodd", strokeLinecap: "round" })));
});
var useStyles = makeStyles(function () { return ({
    root: {
        width: 48,
        height: 48,
        position: 'relative',
    },
    cloud: {
        position: 'absolute',
        top: 12,
        left: 8,
    },
    circle: {
        animation: '$rotate 0.75s linear infinite',
        position: 'absolute',
        top: 18,
        left: 15,
    },
    '@keyframes rotate': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' },
    },
}); }, { name: 'SnAutoSaveRunning' });
/**
 * ### 自動保存のアイコン的コンポーネント
 *
 * アニメーションしないと気づかれないという問題があり、cssで回転を動かすように変更。
 * そのため、素のsvgではなく、複数のsvgを組み合わせている。
 */
export var AutoSaveRunning = React.memo(function (props) {
    var classes = useStyles();
    return (React.createElement("div", { className: classNames(classes.root, props.className) },
        React.createElement(Cloud, __assign({}, props, { className: classes.cloud, ref: null })),
        React.createElement(SemiCircle, __assign({}, props, { className: classes.circle, ref: null }))));
});
